import React, { Fragment } from 'react'
import { ProfileV4DTO } from 'publication-types'

import { TheWestProfile } from 'component-library/content/Profile/TheWestProfile'
import { PerthNowProfile } from 'component-library/content/Profile/PerthNowProfile'
import { SevenNewsProfile } from 'component-library/content/Profile/SevenNewsProfile'
import { ThemedRender } from 'component-library/__styling/themed-render'
import { createRegisterableComponent } from 'common/routing/page-definition'

export interface ProfileRouteProps {
    profileUrl: string
    profile: ProfileV4DTO
}

export const ProfileRegistration = createRegisterableComponent(
    'profile',
    ({ profileUrl, profile }: ProfileRouteProps) => {
        const profileProps = { profile: profile, profileUrl }

        return (
            <Fragment>
                <ThemedRender
                    perthnow={() => <PerthNowProfile {...profileProps} />}
                    sevennews={() => <SevenNewsProfile {...profileProps} />}
                    thewest={() => <TheWestProfile {...profileProps} />}
                />
            </Fragment>
        )
    }
)
